import { queryOptions, skipToken } from '@tanstack/react-query';

import { TaskStatus } from 'chaika-enums';

import { TaskApi } from '@api/TaskApi';

// Задачи меняют и из других сессий, но перезапрашивать список на каждый возврат фокуса на вкладку
// не за что: свои изменения приходят через инвалидацию, чужие — с серверным событием.
const STALE_TIME_MS = 5 * 60 * 1000;

interface ByExecutorsFilters {
    executorIds: string[];
    status?: TaskStatus;
}

export const taskKeys = {
    all: ['task'] as const,
    lists: () => [...taskKeys.all, 'list'] as const,
    byMedicalCase: (medicalCaseId: string) => [...taskKeys.lists(), { medicalCaseId }] as const,
    byExecutors: ({ executorIds, status }: ByExecutorsFilters) =>
        [...taskKeys.lists(), { executorIds: [...executorIds].sort(), status }] as const,
    details: () => [...taskKeys.all, 'detail'] as const,
    detail: (taskId: string) => [...taskKeys.details(), { taskId }] as const,
};

export const taskQueryOptions = {
    detail: (taskId: string) =>
        queryOptions({
            queryKey: taskKeys.detail(taskId),
            queryFn: () => TaskApi.getById(taskId),
        }),
    byMedicalCase: (medicalCaseId: string | undefined) =>
        queryOptions({
            staleTime: STALE_TIME_MS,
            queryKey: taskKeys.byMedicalCase(medicalCaseId ?? ''),
            queryFn: medicalCaseId ? () => TaskApi.find({ medicalCaseId }) : skipToken,
        }),
    byExecutors: ({ executorIds, status }: ByExecutorsFilters) =>
        queryOptions({
            staleTime: STALE_TIME_MS,
            queryKey: taskKeys.byExecutors({ executorIds, status }),
            queryFn:
                executorIds.length > 0 ? () => TaskApi.find({ executorId: executorIds.join(), status }) : skipToken,
        }),
};
